import store from '@/store'
import axios from 'axios'

export default {

  async getWastelessList() {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.get(store.getters.getProductApi + '/wasteless/codes?company_id=' + store.state.company.companyId, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, data: error}
    }
  },

  async saveNewWasteless(wasteless) {
    try {
      let bodyFormData = wasteless
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.post(store.getters.getProductApi + '/wasteless/codes', bodyFormData, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao salvar novo código'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      let msg = 'Erro ao salvar novo código'
      return {error: true, data: error, msg: msg}
    }
  },

  async deleteOfferList(offer) {
    try {
      let result = await axios.delete(store.getters.getProductApi + '/wasteless/codes/' + offer.code)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao excluir código'}
      }
    } catch (e) {
      let error = {e}
      console.log(error)
      return {error: true, data: error}
    }
  }
}


